/**
 * JUB-154: event creation wizard — shared types (mirror of the
 * /api/events/{uuid}/onboarding snapshot, see EventOnboardingService::snapshot).
 */

export type OnboardingType = "wedding" | "baptism" | "wedding_baptism";

/** Schedule slots, in public-page order. */
export type MomentSlot = "civil" | "religious" | "baptism" | "party";
export const MOMENT_SLOTS: MomentSlot[] = ["civil", "religious", "baptism", "party"];

export type CombinedAnswer = "together" | "separate" | "none";

export type GuestsAnswer = "up_to_50" | "up_to_200" | "over_200";
export type GiftsAnswer = "none" | "envelope" | "list";
export type PlanChoice = "free" | "standard" | "premium";

export interface MomentAnswer {
  enabled: boolean;
  title: string | null;
  time: string | null;
  venue: string | null;
  address: string | null;
  city: string | null;
}

export interface OnboardingAnswers {
  type: OnboardingType;
  bride: string | null;
  groom: string | null;
  children: string[];
  parents: { mother: string | null; father: string | null } | null;
  date: string | null;
  dateTbd: boolean;
  combined: CombinedAnswer | null;
  moments: Record<MomentSlot, MomentAnswer>;
  rsvpDeadline: string | null;
  rsvpAcknowledged: boolean;
  packageAnswers: { guests: GuestsAnswer | null; gifts: GiftsAnswer | null; choice: PlanChoice | null } | null;
}

export interface OnboardingSnapshot {
  uuid: string;
  url: string;
  status: "started" | "completed";
  step: string | null;
  progress: number;
  completedSteps: string[];
  skippedSteps: string[];
  language: "ro" | "en";
  theme: string | null;
  plan: PlanChoice;
  answers: OnboardingAnswers;
}

/** Body of PATCH /events/{uuid}/onboarding. */
export interface OnboardingPatch {
  step: string;
  data?: Record<string, unknown>;
  done?: boolean;
  skip?: boolean;
  position?: string;
  progress?: number;
}

export type CompleteVia = "editor" | "guest_view" | "checkout";
